interface Props {
  value: number;
  lo: number;
  hi: number;
  warnLo?: number;
  warnHi?: number;
}

export default function RangeBar({ value, lo, hi, warnLo, warnHi }: Props) {
  // Rango de visualización (expandir un poco más allá de los umbrales)
  const displayMin = warnLo !== undefined ? warnLo * 0.8 : lo * 0.8;
  const displayMax = warnHi !== undefined ? warnHi * 1.2 : hi * 1.2;
  const range = displayMax - displayMin;

  const getPos = (val: number) => {
    const pos = ((val - displayMin) / range) * 100;
    return Math.min(Math.max(pos, 0), 100);
  };

  const currentPos = getPos(value);
  const loPos = getPos(lo);
  const hiPos = getPos(hi);

  return (
    <div style={{ width: '100%', height: '4px', background: '#eee', borderRadius: '2px', position: 'relative', marginTop: '12px', marginBottom: '4px' }}>
      {/* Rango óptimo (verde) */}
      <div 
        style={{ 
          position: 'absolute', 
          left: `${loPos}%`, 
          width: `${hiPos - loPos}%`, 
          height: '100%', 
          background: 'var(--green)', 
          opacity: 0.3 
        }} 
      />

      {/* Marcador de valor actual */}
      <div 
        style={{ 
          position: 'absolute', 
          left: `${currentPos}%`, 
          top: '-3px',
          width: '2px', 
          height: '10px', 
          background: 'var(--dark)',
          borderRadius: '1px',
          zIndex: 2
        }} 
      />

      {/* Umbrales (líneas discretas) */}
      <div style={{ position: 'absolute', left: `${loPos}%`, top: '-2px', width: '1px', height: '8px', background: 'var(--amber)' }} />
      <div style={{ position: 'absolute', left: `${hiPos}%`, top: '-2px', width: '1px', height: '8px', background: 'var(--amber)' }} />
    </div>
  );
}
